import React from 'react';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

const Rooms = () => {
  const { t } = useTranslation('app');
  const {
    setValue: setValueForm,
    watch,
    formState: { errors },
    clearErrors,
  } = useFormContext();
  const value = watch('rooms') || '';
  const isError = errors.rooms;

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    clearErrors('rooms');
    const num = Number(e.target.value);
    if (!isNaN(num)) {
      setValueForm('rooms', num);
    }
  };

  return (
    <div className="flex flex-col gap-2x flex-1">
      <p className="text-title_4 text-black">{t('propertyRooms')}</p>
      <div className="flex flex-col gap-3">
        <div className="flex items-center justify-start gap-2">
          <button
            onClick={() => {
              clearErrors('rooms');
              setValueForm('rooms', value === '' ? 1 : Number(value) + 1);
            }}
            className="w-10 h-10 flex items-center justify-center rounded-lg border border-gray text-gray__dark_2 text-xl active:border-blue_light_1 transition-all"
          >
            +
          </button>

          <input
            type="text"
            value={value}
            placeholder={t('propertyRoomsPlaceholder')}
            onChange={handleChange}
            className={`${isError ? 'border-red_dark' : ''} w-24 h-10 text-center rounded-lg border border-gray text-gray-700 placeholder:text-gray__dark_1 outline-none focus-within:border-blue_light_1 transition-all`}
          />

          <button
            onClick={() => {
              clearErrors('rooms');
              setValueForm('rooms', value === '' ? 1 : Number(value) - 1);
            }}
            disabled={value === '' || value <= 0}
            className="w-10 h-10 flex items-center justify-center rounded-lg border border-gray text-gray__dark_2 text-xl disabled:text-gray active:border-blue_light_1 transition-all"
          >
            –
          </button>
        </div>
        {isError && <p className="text-red_dark">{t('roomsNumberError')}</p>}
      </div>
    </div>
  );
};

export default Rooms;
